import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { StyleSheet, View, ScrollView, TouchableOpacity, ActivityIndicator, TextInput, } from 'react-native';
import Text from 'app/components/Text'
import Value from 'app/components/Value'
// import apiActions from 'app/utils/apiActions'
import valueActions from 'app/utils/valueActions'
import store from 'app/redux/store'

import Form from 'app/components/Form'

export default class CreateView extends React.Component { 
  constructor(props) {
    super(props);
    
    let { navigation, route, } = this.props
    let { text, icon, level, parent_ids, child_ids, children, id, ftue, intermediary, } = !!route && route.params ? route.params : {}

    console.log(route.params)

    text = text || ''
    icon = icon || ''
    parent_ids = !!parent_ids ? (typeof parent_ids == 'string' ? parent_ids.split(',') : parent_ids) : []
    child_ids = []
    if(!!children?.length){
      child_ids = children.map(c => c.id)
    } else {
      child_ids = !!child_ids ? (typeof child_ids == 'string' ? child_ids.split(',') : child_ids) : []
    }
    parent_ids = parent_ids.map(id => parseInt(id))
    child_ids = child_ids.map(id => parseInt(id))
    let template_id = (!!id && typeof id == 'string' && id.includes('ftue')) ? id : null
    this.state = {
      submitting: false,
      error: false,
      ftue,
      id,
      intermediary,
      children,
      value: {
        text,
        icon,
        // level: level || 3,
        parent_ids,
        child_ids,
        template_id,
      },
    }
  }

  handleSubmit = async () => {
    this.setState({submitting: true})
    let { value, id, ftue, intermediary, } = this.state
    // value = await apiActions.request(`values`, 'POST', {value})
    if(!!id && typeof id == 'string'){
      let res = await valueActions.delete({id}, false)
    }
    value = await valueActions.create(value)
    if(!!value){
      
      if(intermediary){
        this.removeIntermediaries(value)
      }

      if(ftue){
        this.props.navigation.popToTop()
      }
      else {
        this.props.navigation.replace('Value', {value, id: value.id})
      }
    }
    else {
      this.setState({submitting: false, error: true})
    }
  }

  removeIntermediaries = async (value) => {
    alert('intermediary should be hanlded server side')
    return
    let { id, child_ids, parent_ids, } = value
    let valueRes = await valueActions.get(id);
    // let { values, app, }  = store.getState()
    // use value from state (since response doesnt have child_ids)
    child_ids.forEach(childId => {
      let child = values.find(v => v.id == childId)
      parent_ids.forEach(parentId => {
        if(child.parent_ids.includes(parentId)){
          let parent = {id: parentId}
          valueActions.removeParent(child, parent)
        }
      })
    })
  }

  handleChangeValue = (key, val) => {
    console.log(key, val)
    let { value } = this.state
    value[key] = val
    this.setState({value})
  }

  render(){
    let { navigation, route, } = this.props
    let { value, submitting, ftue, children, } = this.state
    return (
      <Form
        value={value}
        childIds={value.child_ids}
        children={children}
        onChangeValue={this.handleChangeValue}
        onSubmit={this.handleSubmit}
        submitting={submitting}
        route={route}
        navigation={navigation}
        ftue={ftue}
      />
    );
  }
}